import { addDays, localDayKey, nextMonday, quickDates, zonedTime, type DueChoice } from '@shared/home';

// When a follow-up is due, as the record's composer and the follow-up dialog enter it. Free of the DOM, so
// due.test.ts runs under node.

export interface Due {
  /** 'YYYY-MM-DD'. */
  date: string;
  /** 'HH:mm', or '' for the whole day. */
  time: string;
}

/** Today, Tomorrow, the coming Monday and In a week, each day offered once (on a Sunday the Monday is Tomorrow). */
export function duePicks(now: Date, tz: string): DueChoice[] {
  const seen = new Set<string>();
  return quickDates(now, tz).filter((p) => {
    if (seen.has(p.dueAt)) return false;
    seen.add(p.dueAt);
    return true;
  });
}

/** The day a new follow-up starts on, for the whole day. */
export function startDue(now: Date, tz: string, start: 'tomorrow' | 'monday'): Due {
  const today = localDayKey(now, tz);
  return { date: start === 'monday' ? nextMonday(today) : addDays(today, 1), time: '' };
}

/** What the follow-ups API takes: the moment when a time is set, otherwise the day. */
export function dueBody(due: Due, tz: string): { dueAt: string; hasTime: boolean } {
  if (!due.time) return { dueAt: due.date, hasTime: false };
  return { dueAt: zonedTime(due.date, due.time, tz).toISOString(), hasTime: true };
}
